import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.99935 14.3346C11.4972 14.3346 14.3327 11.4991 14.3327 8.0013C14.3327 4.5035 11.4972 1.66797 7.99935 1.66797C4.50155 1.66797 1.66602 4.5035 1.66602 8.0013C1.66602 9.0062 1.90005 9.95643 2.3166 10.8005C2.35034 10.8688 2.36136 10.9464 2.34603 11.021L1.76573 13.8488C1.71812 14.0807 1.9208 14.287 2.15356 14.2434L5.07483 13.6968C5.14602 13.6835 5.21949 13.694 5.28491 13.7251C6.10761 14.1159 7.02794 14.3346 7.99935 14.3346Z",
      stroke: "#8E8E93",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.54102 8.0013C4.54102 8.25443 4.74622 8.45964 4.99935 8.45964C5.25248 8.45964 5.45768 8.25443 5.45768 8.0013C5.45768 7.74817 5.25248 7.54297 4.99935 7.54297C4.74622 7.54297 4.54102 7.74817 4.54102 8.0013ZM7.54102 8.0013C7.54102 8.25443 7.74622 8.45964 7.99935 8.45964C8.25248 8.45964 8.45768 8.25443 8.45768 8.0013C8.45768 7.74817 8.25248 7.54297 7.99935 7.54297C7.74622 7.54297 7.54102 7.74817 7.54102 8.0013ZM10.541 8.0013C10.541 8.25443 10.7462 8.45964 10.9993 8.45964C11.2525 8.45964 11.4577 8.25443 11.4577 8.0013C11.4577 7.74817 11.2525 7.54297 10.9993 7.54297C10.7462 7.54297 10.541 7.74817 10.541 8.0013Z",
      fill: "#8E8E93",
      stroke: "#8E8E93",
      "stroke-width": "0.25",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }